import { React, Container, Row } from "mondrian-react";

const Loading = () => {
  return (
    <Container>
      <Row>
        <div className={"mcm-PageSpinner"}>
          <div className="mdn-Spinner">
            <i
              className="mdn-Icon-claro mdn-Icon--lg"
              aria-label="Carregando"
              tabIndex="0"
            ></i>
          </div>
        </div>
      </Row>
    </Container>
  );
};

export default Loading;
